/** Profildagi surib o'zgartiriladigan bosqich bari uchun sof hisob-kitoblar (komponentdan alohida, testi bilan). */
import { PIPELINE_ORDER, type DriverStatus } from "./types";

/** Trek bo'ylab x (px) qaysi segmentga to'g'ri keladi: [0, count-1] oralig'ida */
export function stageIndexAt(x: number, width: number, count = PIPELINE_ORDER.length): number {
  if (width <= 0) return 0;
  return Math.min(Math.max(Math.floor((x / width) * count), 0), count - 1);
}

/** Barda bosiladigan/tashlanadigan bosqichlar: ruxsat etilganlardan faqat pipeline yo'lidagilar, hozirgisidan tashqari */
export function barTargets(current: DriverStatus, allowed: DriverStatus[]): Set<DriverStatus> {
  return new Set(PIPELINE_ORDER.filter((s) => s !== current && allowed.includes(s)));
}
